import { useQuery } from '@tanstack/react-query';
import { useDataProvider } from '@/data/provider';
import { queryKeys } from '@/lib/query-keys';
import type { WorkingSetStatus } from '@/data/provider/types';

const EMPTY_WORKING_SET_STATUS: WorkingSetStatus = {
  lastRefreshAt: null,
  counts: {
    companies: 0,
    sites: 0,
    units: 0,
    contacts: 0,
    reports: 0,
    templates: 0,
    catalogs: 0,
  },
  isReady: false,
};

export function useWorkingSetStatus() {
  const { workingSet } = useDataProvider();
  return useQuery({
    queryKey: queryKeys.workingSet.status(),
    queryFn: () => workingSet.getStatus(),
    initialData: EMPTY_WORKING_SET_STATUS,
  });
}
